import { useMemo, useState } from 'react';
export const useCredentials = props => {
  const {
    fields
  } = props;
  const [shouldShowErrorForBlankFields, setShouldShowErrorForBlankFields] = useState(false);
  const [credentials, setCredentials] = useState(() => {
    return (fields == null ? void 0 : fields.reduce((acc, field) => {
      acc[field.name] = field.hiddenValue ?? '';
      return acc;
    }, {})) ?? {};
  });
  const hasBlankFields = useMemo(() => {
    return Object.values(credentials).some(value => !value.trim());
  }, [credentials]);
  return {
    shouldShowErrorForBlankFields,
    setShouldShowErrorForBlankFields,
    hasBlankFields,
    credentials,
    setCredentials
  };
};
//# sourceMappingURL=useCredentials.js.map